import { PdsClientEventName } from '../../shared';

// check whether application is loaded inside iframe.
export const isInIframe = window.self !== window.top;
// check whether application is loaded inside popup. etc, opened by window.open()
export const isPopupWindow = !!window.opener;
// check if it's a child window. etc, iframe or a popup.
export const parentWindow = window.opener ?? window.parent;

export const notifyVendorPostSsoLogin = (authSuccess = false) => {
  if (!isPopupWindow) {
    return;
  }
  const data = {
    type: authSuccess
      ? PdsClientEventName.CLIENT_SSO_AUTHENTICATION_SUCCESS
      : PdsClientEventName.CLIENT_SSO_AUTHENTICATION_FAILED,
    data: {},
  };
  parentWindow.postMessage(data, '*');
};
